var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { TopWrapper, TopButton, } from "./components";
import { DropDownList } from "../../elements/dropdown.list/index";
import { Tooltip } from "../../tooltip/index";
import { FaSync, FaDownload } from "react-icons/fa";
let ProtableTopBar = class ProtableTopBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { store, showExportModule } = this.props;
        const s = store.s;
        return (React.createElement(TopWrapper, null,
            React.createElement(TopButton, { className: "text-left", onClick: () => store.update({
                    dropdown: s.dropdown === "filters" ? "" : "filters",
                }) }, "Filters"),
            React.createElement(DropDownList, { onSelect: (selected) => {
                    store.update({ limit: selected.value });
                    store.fetch();
                }, options: [
                    { label: "10 Results", value: 10 },
                    { label: "25 Results", value: 25 },
                    { label: "50 Results", value: 50 },
                ] },
                React.createElement(TopButton, { className: "max128 width128" },
                    s.limit,
                    " Results")),
            React.createElement(Tooltip, { text: "Refresh", width: 65, position: "top" },
                React.createElement(TopButton, { className: "max48", onClick: store.fetch },
                    React.createElement(FaSync, null))),
            showExportModule && (React.createElement(Tooltip, { text: "Export", width: 65, position: "top" },
                React.createElement(TopButton, { className: "max48", onClick: () => store.update({
                        dropdown: s.dropdown === "export" ? "" : "export",
                    }) },
                    React.createElement(FaDownload, null))))));
    }
};
ProtableTopBar = __decorate([
    observer
], ProtableTopBar);
export { ProtableTopBar };
//# sourceMappingURL=top.js.map